export const overviewFeedbackStyles = (interactionLevel: number) => {
  if (interactionLevel === 1) {
    return 'red';
  }
  if (interactionLevel === 2) {
    return 'orange';
  }
  if (interactionLevel === 3) {
    return 'green';
  }
  return 'primary';
};

export const ActionType = {
  UNATTEMPTED_NON_PRIMARY_NUMBERS: 'UNATTEMPTED_NON_PRIMARY_NUMBERS'
};
